import React from 'react';
import Form from 'components/form';
import AnswerOptions from 'routes/surface/components/node-modal-form/components/questionnaire-node-modal/components/questionnaire-node-form/components/answer-options';
import If from 'components/if-statement';
import { useTranslation } from 'i18n';
import { Header } from 'routes/surface/components/node-modal-form/style';
import {
  Container,
  AnswerSection,
  NameTextInput,
  DisabledName,
  QuestionInput,
  QuestionIcon,
  CloseIcon,
} from './style';
import { H2 } from 'components/typography';
import { object, string } from 'yup';
import { isMobile } from 'react-device-detect';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import { ErrorMessage } from 'components/textautosize/style';
import { NodeModalInput } from 'types';
import { SurfaceQuestionnaireNode } from 'graphql/types';
import useCanCreateOrEditSurfaceNode from 'routes/surface/components/node-modal-form/hooks/use-can-create-or-edit-surface-node';
import { CortlexThemedTemplate, ThemedTemplate } from 'routes/template';

export interface QuestionnaireFormFormProps {
  onSubmit: Function;
  onCancel: Function;
  data: NodeModalInput<SurfaceQuestionnaireNode>;
  saveNodeInCache: (node: any) => any;
}

const defaultProps = {};

function createValidationSchema(t) {
  return function () {
    return object().shape({
      name: string().required(t('name is required')),
      question: string().required(t('question is required')),
      answerType: string().required(t('answer type is required')),
    });
  };
}

function QuestionnaireFormForm({
  data,
  onSubmit,
  ...props
}: QuestionnaireFormFormProps) {
  const { t } = useTranslation();

  const validationSchema = React.useMemo(createValidationSchema(t), []);

  const {
    canCreateOrEdit,
    isUpdate,
    cannotEdit,
  } = useCanCreateOrEditSurfaceNode(data);

  const submitLabel = isUpdate
    ? t('Update questionnaire')
    : t('Insert questionnaire');

  async function formSubmit(values, actions) {
    const response = await onSubmit(values, actions);

    if (response.isFailure) {
      // Error will be handled in onSubmit
      return;
    }

    const node = response.getField('data');

    props.saveNodeInCache(node);
  }

  function clearQuestion(form) {
    return function () {
      if (cannotEdit) {
        return;
      }

      form.setFieldValue('question', '');
    };
  }

  function isNameInputAutoFocused() {
    if (isUpdate) {
      return isMobile ? false : true;
    }

    return true;
  }

  return (
    <Form
      initialValues={data}
      validationSchema={validationSchema}
      onSubmit={formSubmit}>
      {(form) => {
        const answerTypeError = form.errors['answerType'];
        return (
          <>
            <Header>
              <Form.Button
                label={t('Close')}
                onClick={props.onCancel}
                secondary
              />
              {/* {canCreateOrEdit && (
                <Form.SubmitButton
                  label={submitLabel}
                  onClick={form.handleSubmit}
                />
              )} */}
            </Header>
            {/* <Container> */}
            <CortlexThemedTemplate onDone={props.onCancel} />
            {/* </Container> */}
          </>
        );
      }}
    </Form>
  );
}

QuestionnaireFormForm.defaultProps = defaultProps;

export default QuestionnaireFormForm;
